import { useEffect, useState } from "react"

/** True only once `flag` has stayed true for `delayMs`; drops to false immediately. Avoids loader flashes on fast requests. */
export function useDelayedFlag(flag: boolean, delayMs: number): boolean {
    const [delayed, setDelayed] = useState(false)

    useEffect(() => {
        if (!flag) {
            setDelayed(false)
            return
        }
        const timer = setTimeout(() => setDelayed(true), delayMs)
        return () => clearTimeout(timer)
    }, [flag, delayMs])

    return flag && delayed
}
